import { createSlice } from '@reduxjs/toolkit'
import { IndicatorIndex } from '../../../interfaces/IndicatorIndex';
import { getIndicatorIndex } from './indicatorIndexThunk';


interface methodologiesState {
    indicatorIndex: IndicatorIndex | null;
    loading: "idle" | "pending" | "succeeded" | "failed";
    selectedLetter: string;
}

const initialState: methodologiesState = {
    loading: 'idle',
    indicatorIndex: null,
    selectedLetter: ''
}

export const indicatorIndexSlice = createSlice({
    name: 'indicatorIndex',
    initialState,
    reducers: {
        selectedLetter: (state, action) => {
            if (!state.selectedLetter) return

            state.selectedLetter = action.payload.letter;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getIndicatorIndex.pending, (state) => {
            state.loading = "pending";
        });
        builder.addCase(getIndicatorIndex.fulfilled, (state, action) => {
            state.loading = "succeeded";
            state.indicatorIndex = action.payload.indicator_index;
        });
        builder.addCase(getIndicatorIndex.rejected, (state) => {
            state.loading = "failed";
        });
    },
})

export const { selectedLetter } = indicatorIndexSlice.actions;

export default indicatorIndexSlice.reducer;